export default __webpack_public_path__ + "static/media/trolleyfinder-logo.d2114625.png";